import { z } from 'zod';
import { FlowRoleSchema } from './role';

/**
 * Flow identity wire contract — GET /api/flow/identity. Resolved server-side
 * from the acting user's SF mirror row (src/services/flow/identity.ts) and
 * consumed client-side to seed role-based default filters on the account/
 * contact Command Center tables (web/app-home/src/components/flow/
 * roleDefaults.ts). `null` means "no role default" — no SF match, no
 * detected role, or no name to filter by (admin / unrecognized role /
 * unmapped email all collapse to this).
 */

export const FlowIdentitySchema = z.object({
  flowRole: FlowRoleSchema,
  /** salesforce_user.name — the same value that populates owner_name/claydr_name columns. */
  sfDisplayName: z.string(),
  /**
   * salesforce_user.id — lets the frontend show viewer resolution for a
   * `{me}` chip ("ClayDR is [Me] → Spencer Chemtob", Decision 6). Null only
   * when the identity itself failed to resolve — in practice `sfDisplayName`
   * and `sfUserId` come from the same matched row, so this is non-null
   * whenever `FlowIdentity` exists at all; kept nullable defensively rather
   * than widening the (already-nullable) response envelope.
   */
  sfUserId: z.string().nullable(),
});
export type FlowIdentity = z.infer<typeof FlowIdentitySchema>;

export const FlowIdentityResponseSchema = z.object({
  identity: FlowIdentitySchema.nullable(),
});
export type FlowIdentityResponse = z.infer<typeof FlowIdentityResponseSchema>;
